export default {
  title: 'Hilfe und FAQs',
  buttons: {
    faqs: 'FAQs',
    contact_us: 'Kontaktieren Sie uns',
  },
};
